<template>
  <div v-if="screenMobile" class="pure-color-background" @click="handleClick" :style="backgroundSyle"></div>
  <div v-else class="pure-color-background" @click="handleClick" :style="backgroundSyle"></div>
</template>

<script>
export default {
  name: 'PureColorBackground',
  components: {},
  props: {
    ProjectInfo: Object,
    /* 等比缩放需要使用ProjectInfo

     ProjectInfo.ScreenRatio: {
        w_Ratio: 100,  单位%   宽度缩放比
        h_Ratio: 100,  单位%   高度缩放比
      },
    */
    Configuration: Object,
  },
  data() {
    return {
      backgroundSyle: {},
      screenMobile: false,
    };
  },
  created() {
    this.screenMobile = this.$store.state.isMobile;
    this.getBackgroundStyle();
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        this.getBackgroundStyle();
      },
    },
    isMobile: {
      deep: true,
      handler: function (vn, vo) {
        this.screenMobile = vn;
        this.getBackgroundStyle();
      },
    },
  },

  methods: {
    getBackgroundStyle() {
      if (this.screenMobile == true) {
        for (let key in this.Configuration.style) {
          /* 如果有格式装换请勿使用下一句
        格式转换例如
          Configuration.style.width = '100%' =>  '100%'
          Configuration.style.width = 100 =>  '100px'
        */
          this.backgroundSyle[key] = this.Configuration.style[key];
        }
        this.backgroundSyle.backgroundColor = this.Configuration.propertyData.backgroundColor.value;
        let backgroundHeight = this.ProjectInfo.ScreenSize.height;
        this.backgroundSyle.height = backgroundHeight + 'px';
      } else {
        for (let key in this.Configuration.style) {
          this.backgroundSyle[key] = this.Configuration.style[key];
        }
        this.backgroundSyle.backgroundColor = this.Configuration.propertyData.backgroundColor.value;
      }
    },
    handleClick(e) {
      e.stopPropagation();
      this.$store.commit('set_CurrentConfigration', this.Configuration);
      this.$store.commit('set_ContextMenu', {
        isOpen: false,
      });
    },
  },
  computed: {},
  Configuration: {
    componentTitle: '纯色背景',
    componentName: 'PureColorBackground',
    componentOverViewImg: './img/backgrounds/PureColorBackground.png',
    id: 'PureColorBackground',
    style: {
      backgroundColor: 'rgba(7, 26, 45, 1)',
    },
    propertyData: {
      backgroundColor: {
        propertyComponentName: 'SingleColorSelector',
        configurationAccessKey: 'style',
        value: 'rgba(7, 26, 45, 1)',
        lable: '背景颜色',
      },
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.pure-color-background {
  overflow: hidden;
  width: 100%;
  height: 100%;
}
</style>
